// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/iam/auditlog/auditlog.actions.go

export const LIST_LOGS = "mondoo.auditlog.AuditLogManager.ListLogs";
